import { render, staticRenderFns } from "./te-modal.vue?vue&type=template&id=76203888"
import script from "./te-modal.vue?vue&type=script&lang=js"
export * from "./te-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports